import { setError } from "./validation.js";
import getLocale from "./getLocale.ts";
import Vue from "vue";
import messages from "../language";
import VueI18n from "vue-i18n";
import provinceTripLimits from "../config/provinceTripLimits.js";
import bus from "./bus.js";
Vue.use(VueI18n);

export function validateBirthDate(field, newValue, wantsMedical) { 
  
  const date15DaysAgo = new Date();
  date15DaysAgo.setDate(date15DaysAgo.getDate() - 15);
  const date65YearsAgo = new Date();
  date65YearsAgo.setDate(date65YearsAgo.getDate() - 65 * 365);
  const date89YearsAgo = new Date();
  date89YearsAgo.setDate(date89YearsAgo.getDate() - 89 * 365);
  const date130YearsAgo = new Date();
  date130YearsAgo.setDate(date130YearsAgo.getDate() - 130 * 365);

  // Checks for special date before/after rules.
  let isValid = true;
  const bDate = new Date(newValue);
  
  if(!(newValue===""&&!(field.classList.contains("is-invalid")||field.classList.contains("is-valid")))){
    // Load localization
    const locale = getLocale();
    const i18n = new VueI18n({
      locale: locale, // set locale
      messages // set locale messages
    });
    // Check blank/invalid
    // IE bugs
    if(field.value.substring(3, 5)==="00"||field.value.substring(0, 2)==="00"||field.value.substring(0, 2)>12) {
      isValid = false;
      if(field.classList.contains("is-valid")){
        field.classList.remove("is-valid");
        field.classList.add("is-invalid");
      }
      setError(field, i18n.t("text.invalid_dateofbirth"), "1006");
    }
    else if(isNaN(Date.parse(bDate)) === true || (field.value.length <8&&field.value.length>0) ){
      isValid = false;
      if(field.classList.contains("is-valid")){
        field.classList.remove("is-valid");
        field.classList.add("is-invalid");
      }
      setError(field, i18n.t("text.invalid_dobempty"), "1005");
    }
    else if ( bDate > date15DaysAgo || bDate < date130YearsAgo) {
      isValid = false;
      if(field.classList.contains("is-valid")){
        field.classList.remove("is-valid");
        field.classList.add("is-invalid");
      }
      setError(field, i18n.t("text.invalid_dateofbirth"), "1006");
    }
    // Check for age over 89, if there is no medical coverage
    else if(bDate< date89YearsAgo&&wantsMedical===false){
      if(field.classList.contains("is-valid")){
        field.classList.remove("is-valid");
        field.classList.add("is-invalid");
      }
      setError(field, i18n.t("text.invalid_dateofbirth"), "1006");
    }
    // Check there aren't two users over 65
    else if (bDate < date65YearsAgo&&wantsMedical===true) {
      // Go through all other birthdate fields.
      let targetFields = document.getElementsByClassName('vdp-datepicker');
      for(const targetField of targetFields) {
        const otherDate = new Date(targetField.firstChild.childNodes[2].value);
        if(field!==targetField.firstChild.childNodes[2]){
          if(otherDate < date65YearsAgo){
            isValid=false;
            if(field.classList.contains("is-valid")){
              field.classList.remove("is-valid");
              field.classList.add("is-invalid");
            }
            setError(field, i18n.t("text.invalid_dateofbirthtwomedical"),"1007");
          }
        }
      }
      if(isValid===true){
        if(field.classList.contains("is-invalid")){
          field.classList.remove("is-invalid");
          field.classList.add("is-valid");
        }
        setError(field);
      }
    }
    else {
      if(field.classList.contains("is-invalid")){
        field.classList.remove("is-invalid");
        field.classList.add("is-valid");
      }
      setError(field);
    }
  }
  return isValid;
}
export function validateDepartureDate(dDate = new Date(document.getElementById("departureDate").value)) {
  const departureDate = document.getElementById("departureDate");
  const maximumDepartureDate = new Date();
  maximumDepartureDate.setDate(maximumDepartureDate.getDate() + 540);
  // Checks for special date before/after rules.
  let isValid = true;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  if(!(isNaN(Date.parse(dDate))&&!(departureDate.classList.contains("is-invalid")||departureDate.classList.contains("is-valid")))){
    // Load localization values
    const locale = getLocale();
    const i18n = new VueI18n({
      locale: locale, // set locale
      messages // set locale messages
    });
    
    // IE 00 bug
    if(departureDate.value.substring(3, 5)==="00"||departureDate.value.substring(0, 2)==="00") {
      isValid = false;
      if(departureDate.classList.contains("is-valid")){
        departureDate.classList.remove("is-valid");
        departureDate.classList.add("is-invalid");
      }
      setError(departureDate, i18n.t("text.invalid_departureDate"), "1002");
    }
    // Check blank/invalid, before today, or more than 180 days in the future.
    else if (dDate < today || isNaN(Date.parse(dDate)) === true|| (departureDate.value.length <8&&departureDate.value.length>0)) {
      isValid = false;
      if(departureDate.classList.contains("is-valid")){
        departureDate.classList.remove("is-valid");
        departureDate.classList.add("is-invalid");
      }
      setError(departureDate, i18n.t("text.invalid_departureDate"), "1002");
    }
    // Hide or Show warning if date is more than 180 days in the future
    else if (dDate > maximumDepartureDate) {
      isValid = false;
      if(departureDate.classList.contains("is-valid")){
        departureDate.classList.add("is-invalid");
        departureDate.classList.remove("is-valid");
      }
      const locale = getLocale();
      const i18n = new VueI18n({
        locale: locale, // set locale
        messages // set locale messages
      });
      setError(departureDate, i18n.t("text.invalid_futuredate"), "1001");
    }
    else {
      isValid = true;
      if(departureDate.classList.contains("is-invalid")){
        departureDate.classList.remove("is-invalid");
        departureDate.classList.add("is-valid");
      }
      setError(departureDate);
    }
  }

  if(isValid===false){
    departureDate.setAttribute('aria-invalid','true');
  }
  else {
    departureDate.setAttribute('aria-invalid','false');
  }
  return isValid;
}
export function validateReturnDate(
  rDate = new Date(document.getElementById("returnDate").value),
  dDate = new Date(document.getElementById("departureDate").value)
) {
  // Manually defined these so it runs in IE.
  const returnDate = document.getElementById("returnDate");

  // Checks for special date before/after rules.
  let isValid = true;
  if(!(rDate===""&&!(returnDate.classList.contains("is-invalid")||returnDate.classList.contains("is-valid")))){
    
    // Load localization text
    const locale = getLocale();
    const i18n = new VueI18n({
      locale: locale, // set locale
      messages // set locale messages
    });

    // Calculate maximum trip length
    const maxTripLength = new Date(dDate);
    maxTripLength.setDate(maxTripLength.getDate() + provinceTripLimits(document.getElementById('province').value));
    const roundeddDate= new Date(dDate.getFullYear(), dDate.getMonth(), dDate.getDate(), 0, 0, 0);
    // alert(document.getElementById("returnDate").value+" - "+rDate+" - "+roundeddDate);
    // Check for 00 Day or Month values, bug in IE.
    if(returnDate.value.substring(3, 5)==="00"||returnDate.value.substring(0, 2)==="00") {
      isValid = false;
      if(returnDate.classList.contains("is-valid")){
        returnDate.classList.remove("is-valid");
        returnDate.classList.add("is-invalid");
      }
      setError(returnDate, i18n.t("text.invalid_returnDate"), "1003");
    }
    // Check blank/invalid or before departure date.
    else if (rDate < roundeddDate || isNaN(Date.parse(rDate)) === true|| (returnDate.value.length <8&&returnDate.value.length>0)) {
      if(returnDate.classList.contains("is-valid")){
        returnDate.classList.remove("is-valid");
        returnDate.classList.add("is-invalid");
        isValid=false;
      }
      if(rDate < roundeddDate) {setError(returnDate, i18n.t("text.invalid_returndatebefore"), "1004");}
      else {setError(returnDate, i18n.t("text.invalid_returnDate"), "1003");}
    } else if(rDate >= maxTripLength) {
      if(returnDate.classList.contains("is-valid")){
        returnDate.classList.remove("is-valid");
        returnDate.classList.add("is-invalid");
        isValid=false;
      }
      setError(returnDate, i18n.t("text.invalid_triplength").replace('212',provinceTripLimits(document.getElementById('province').value)), "1025");
    } else {
      if(returnDate.classList.contains("is-invalid")){
        returnDate.classList.add("is-valid");
        returnDate.classList.remove("is-invalid");
      }
      setError(returnDate);
    }
  }

  if(isValid===false){
    returnDate.setAttribute('aria-invalid','true');
  }
  else {
    returnDate.setAttribute('aria-invalid','false');
  }
  return isValid;
}

export function validateCoverageStartDate(sDate = new Date(document.getElementById("tripStart").value), departureDate=new Date(document.getElementById("departureDate").value)) {
  // Manually defined these so it runs in IE.
  const coverageStart = document.getElementById("tripStart");

  // Checks for special date before/after rules.
  let isValid = true;
  if(!(sDate===""&&!(coverageStart.classList.contains("is-invalid")||coverageStart.classList.contains("is-valid")))){
    
    // Load localization text
    const locale = getLocale();
    const i18n = new VueI18n({
      locale: locale, // set locale
      messages // set locale messages
    });

    // Calculate maximum trip length
    const today = new Date();
    const latestCoverageStart = new Date().setDate(today.getDate() + 30);
    const roundedToday= new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
    // Check for 00 Day or Month values, bug in IE.
    if(coverageStart.value.substring(3, 5)==="00"||coverageStart.value.substring(0, 2)==="00") {
      isValid = false;
      if(coverageStart.classList.contains("is-valid")){
        coverageStart.classList.remove("is-valid");
        coverageStart.classList.add("is-invalid");
      }
      setError(coverageStart, i18n.t("text.invalid_coverageStartDate"), "1017");
    }
    // Check blank/invalid or before today
    else if (sDate < roundedToday || isNaN(Date.parse(sDate)) === true|| (coverageStart.value.length <8&&coverageStart.value.length>0)) {
      if(coverageStart.classList.contains("is-valid")){
        coverageStart.classList.remove("is-valid");
        coverageStart.classList.add("is-invalid");
        isValid=false;
      }
      if(sDate < today) {setError(coverageStart, i18n.t("text.invalid_coverageStartDateEarly"), "1018");}
      else {setError(coverageStart, i18n.t("text.invalid_coverageStartDate"), "1017");}
    } else if(sDate >= latestCoverageStart) {
      if(coverageStart.classList.contains("is-valid")){
        coverageStart.classList.remove("is-valid");
        coverageStart.classList.add("is-invalid");
        isValid=false;
      }
      setError(coverageStart, i18n.t("text.invalid_coverageStartDateLate"), "1019");
    } else if (departureDate<sDate){
      if(coverageStart.classList.contains("is-valid")){
        coverageStart.classList.remove("is-valid");
        coverageStart.classList.add("is-invalid");
        isValid=false;
      }
      setError(coverageStart, i18n.t("text.invalid_coverageStartDate"), "1017");
    } else {
      if(coverageStart.classList.contains("is-invalid")){
        coverageStart.classList.add("is-valid");
        coverageStart.classList.remove("is-invalid");
      }
      setError(coverageStart);
    }
  }

  if(isValid===false){
    coverageStart.setAttribute('aria-invalid','true');
  }
  else {
    coverageStart.setAttribute('aria-invalid','false');
  }
  return isValid;
}

export function validateOldestTraveller(age=document.getElementById('oldestTraveller').value, wantsMedical, site){
  var isValid=true;
  // Load localization text
  const locale = getLocale();
  const i18n = new VueI18n({
    locale: locale, // set locale
    messages // set locale messages
  });

  const targetField = document.getElementById('oldestTraveller');

  if(age<0){
    targetField.value='0';
  }
  else if(age>130){
    age = age.toString().substring(0, age.length - 1);
    targetField.value=age;
  }
  else if(age>89&&wantsMedical===false){
    targetField.classList.remove("is-valid");
    targetField.classList.add("is-invalid");
    setError(targetField, i18n.t("text.invalid_dateofbirth"), "1006");
    isValid=false;
  }  

  if(wantsMedical===true&&age>=60) {
    document.getElementById("lbl_numberOfTravellers").innerHTML=i18n.t('text.page3_input1b');
    document.getElementById("numberOfTravellers").setAttribute("disabled","disabled");
    if(document.getElementById("numberOfTravellers").value>1){
      if(site==="cibc"){
        document.getElementById("keywordBody").innerHTML=i18n.t("text.page3_input2_tooltip")+i18n.t("text.contactSnippet");
        bus.$emit("openModal");
      }
      else {
        document.getElementById("keywordBody").innerHTML=i18n.t("text.page3_input2_tooltipnm")+i18n.t("text.contactSnippetnm");
        bus.$emit("openModal");
      }
      document.getElementById("numberOfTravellers").value=1;
    }
  } else {
    document.getElementById("lbl_numberOfTravellers").innerHTML=i18n.t('text.page3_input1');
    document.getElementById("numberOfTravellers").removeAttribute("disabled");
  }

  if(isValid===false){
    targetField.setAttribute('aria-invalid','true');
  }
  else {
    targetField.setAttribute('aria-invalid','false');
  }
  return isValid;
}

export function validateTripCost(site, cost=document.getElementById('tripCost').value){
  var isValid=true;
  // Load localization text
  const locale = getLocale();
  const i18n = new VueI18n({
    locale: locale, // set locale
    messages // set locale messages
  });

  const targetField = document.getElementById('tripCost');
  if(cost<0){
    targetField.value="0";
  }
  else if(cost>50000) {
    targetField.classList.remove("is-valid");
    targetField.classList.add("is-invalid");
    isValid=false;
    if(site==="cibc") {
      setError(targetField, i18n.t("text.invalid_tripCost"), "1027");
    }
    else {
      setError(targetField, i18n.t("text.invalid_tripCostnm"), "1027");
    }
  }
  else {
    targetField.classList.add("is-valid");
    targetField.classList.remove("is-invalid");    
  }

  if(isValid===false){
    targetField.setAttribute('aria-invalid','true');
  }
  else {
    targetField.setAttribute('aria-invalid','false');
  }
  return isValid;
}

export function validateEmail(newValue=document.getElementById("email").value){
  let isValid=true;

  // Load localization text
  const locale = getLocale();
  const i18n = new VueI18n({
    locale: locale, // set locale
    messages // set locale messages
  });
 
  const targetField = document.getElementById('email');
  document.getElementById("lbl_fulfillment").parentNode.parentNode.style.display='none';

  const mask = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // Check if new Value matches mask
  if(newValue===""){
    targetField.classList.remove("is-valid");
    document.getElementById
  }
  else if(mask.test(String(newValue)) === false) {
    isValid = false;
    if(targetField.classList.contains("is-valid")){
      targetField.classList.add("is-invalid");
      targetField.classList.remove("is-valid");
      setError(targetField, i18n.t("text.invalid_email"), "1016");
    }
  }
  else if(mask.test(String(newValue)) === true){
    targetField.classList.remove("is-invalid");
    targetField.classList.add("is-valid");
    setError(targetField);
    document.getElementById("lbl_fulfillment").parentNode.parentNode.style.display='block';
  }

  if(isValid===false){
    targetField.setAttribute('aria-invalid','true');
  }
  else {
    targetField.setAttribute('aria-invalid','false');
  }
  return isValid;
}